import { render, staticRenderFns } from "./EnviarCorreo.vue?vue&type=template&id=1244bfdc&scoped=true&"
import script from "./EnviarCorreo.vue?vue&type=script&lang=js&"
export * from "./EnviarCorreo.vue?vue&type=script&lang=js&"
import style0 from "./EnviarCorreo.vue?vue&type=style&index=0&id=1244bfdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244bfdc",
  null
  
)

export default component.exports